module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphData.title[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])])])])]), _vm._v(" "), (_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [(_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.crunchedData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 align-center"
  }, _vm._l((_vm.graphData.traces), function(trace, index1) {
    return _c('div', {
      staticClass: "col-sm-3 col-md-12",
      attrs: {
        "align": "left"
      }
    }, [(index1 % 5 === 0) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 1) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-danger"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 2) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-primary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 3) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-default"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 4) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-warning"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e()])
  }), 0)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c8fdcef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/ApiDeviceGraphBarMultipleV1p00.vue
// module id = 1500
// module chunks = 4